export const MemoryLockGlyph = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true" style={{ filter: "drop-shadow(0 0 5px rgba(212,175,55,0.35))" }}>
    <defs>
      <linearGradient id="ml-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f3e5ab" />
        <stop offset="0.55" stopColor="#d4af37" />
        <stop offset="1" stopColor="#aa8c2c" />
      </linearGradient>
    </defs>
    <path d="M23 30 V22 a9 9 0 0 1 18 0 V30" stroke="url(#ml-gold)" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M26.5 30 V22.5 a5.5 5.5 0 0 1 11 0 V30" stroke="url(#ml-gold)" strokeWidth="0.8" strokeLinecap="round" opacity="0.5" />
    <rect x="17" y="29" width="30" height="25" rx="11" stroke="url(#ml-gold)" strokeWidth="1.6" />
    <rect x="20.5" y="32.5" width="23" height="18" rx="8" stroke="url(#ml-gold)" strokeWidth="0.7" opacity="0.4" />
    <path fillRule="evenodd" fill="url(#ml-gold)" d="M30.5 37.5 a6 6 0 1 0 0.01 0 Z M34.3 40.6 a4.7 4.7 0 1 1 -0.01 0 Z" />
    <path d="M41 36.6 l0.9 2 2 0.9 -2 0.9 -0.9 2 -0.9 -2 -2 -0.9 2 -0.9 Z" fill="#f3e5ab" opacity="0.9" />
    <path d="M12.5 13.5 l1 2.4 2.4 1 -2.4 1 -1 2.4 -1 -2.4 -2.4 -1 2.4 -1 Z" fill="#d4af37" opacity="0.75" />
    <path d="M52 22 l0.7 1.7 1.7 0.7 -1.7 0.7 -0.7 1.7 -0.7 -1.7 -1.7 -0.7 1.7 -0.7 Z" fill="#e9b8d0" opacity="0.6" />
    <circle cx="51" cy="47" r="0.9" fill="#d4af37" opacity="0.5" />
  </svg>
);
